import React from 'react';
import { Eye, Target, CheckCircle } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
export function VisionMission() {
  const {
    t
  } = useLanguage();
  return <section className="w-full py-16 md:py-24 bg-white" data-id="element-283">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-284">
        {/* Section Header */}
        <div className="text-center mb-12" data-id="element-285">
          <span className="inline-block px-4 py-1.5 bg-emerald-100 text-emerald-700 rounded-full text-sm font-semibold mb-4" data-id="element-286">
            {t.visionMission.badge}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-287">
            {t.visionMission.title}
          </h2>
        </div>

        {/* Cards Grid */}
        <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-288">
          {/* Vision Card */}
          <div className="bg-gradient-to-br from-emerald-600 to-emerald-700 rounded-3xl p-8 md:p-10 text-white shadow-xl" data-id="element-289">
            <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mb-6 backdrop-blur-sm" data-id="element-290">
              <Eye className="w-8 h-8 text-white" data-id="element-291" />
            </div>
            <h3 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-292">
              {t.visionMission.vision.title}
            </h3>
            <p className="text-emerald-100 text-lg leading-relaxed" data-id="element-293">
              {t.visionMission.vision.text}
            </p>
          </div>

          {/* Mission Card */}
          <div className="bg-gradient-to-br from-emerald-700 to-emerald-800 rounded-3xl p-8 md:p-10 text-white shadow-xl" data-id="element-294">
            <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mb-6 backdrop-blur-sm" data-id="element-295">
              <Target className="w-8 h-8 text-white" data-id="element-296" />
            </div>
            <h3 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-297">
              {t.visionMission.mission.title}
            </h3>
            <ul className="space-y-3" data-id="element-298">
              {t.visionMission.mission.points.map((point, index) => <li key={index} className="flex items-start gap-3" data-id="element-299">
                  <CheckCircle className="w-5 h-5 text-emerald-300 flex-shrink-0 mt-0.5" data-id="element-300" />
                  <span className="text-emerald-100" data-id="element-301">{point}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}